/** US timezone options for the slot picker's time-zone toggle. */
export const US_TIMEZONES: ReadonlyArray<{ tz: string; label: string }> = [
  { tz: 'America/New_York', label: 'Eastern (ET)' },
  { tz: 'America/Chicago', label: 'Central (CT)' },
  { tz: 'America/Denver', label: 'Mountain (MT)' },
  { tz: 'America/Phoenix', label: 'Arizona (MST)' },
  { tz: 'America/Los_Angeles', label: 'Pacific (PT)' },
  { tz: 'America/Anchorage', label: 'Alaska (AKT)' },
  { tz: 'Pacific/Honolulu', label: 'Hawaii (HT)' },
];
const ALLOWED = new Set(US_TIMEZONES.map((t) => t.tz));

/** The visitor's browser timezone if it's a US zone we offer, else Eastern. */
export function browserDefaultTz(): string {
  try {
    const t = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return ALLOWED.has(t) ? t : 'America/New_York';
  } catch {
    return 'America/New_York';
  }
}
